import React__default from 'react';
import classNames from 'classnames';
import styles from './Menu2.js';
import '../Input/index.js';
import '../../icons/index.es.js';
import Input from '../Input/Input.js';
import SearchIcon from '../../icons/components/SearchIcon.js';

const MenuSearch = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    setSearchValue,
    animatedLeft,
    animatedRight,
    dataTestId,
    searchValue = '',
    isInteractive = false,
    searchPlaceholder,
    inputRef
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.searchBox, {
      [styles.unresponsive]: !isInteractive,
      [styles.animatedLeft]: animatedLeft,
      [styles.animatedRight]: animatedRight
    }),
    ref: ref
  }, /*#__PURE__*/React__default.createElement(Input, {
    ref: inputRef,
    "data-testid": dataTestId,
    role: "searchbox",
    value: searchValue,
    onChange: e => setSearchValue(e.target.value),
    placeholder: searchPlaceholder,
    leftAddOn: /*#__PURE__*/React__default.createElement(SearchIcon, null),
    className: styles.searchInput
  }));
});

export { MenuSearch as default };
